module.exports = __webpack_public_path__ + "img/gameTronos6.4d8bfda2.jpg";